/**
 * @typedef {object} RecommendationItem
 * @property {string} id
 * @property {string} name
 * @property {number} position
 * @property {number} [price]
 * @property {string} [strategyId]
 *
 * @typedef {object} RecommendationsMeta
 * @property {number} numResults
 * @property {string} podDisplayName
 * @property {string} podId
 * @property {string} resultId
 * @property {string[]} seedItemIds
 * @property {string} strategyId
 * @property {number} totalNumResults
 *
 * @typedef {object} TransformedRecommendationsResponse
 * @property {RecommendationItem[]} items
 * @property {RecommendationsMeta} meta
 *
 * @param {import('@constructor-io/constructorio-client-javascript').RecommendationsResponse} response
 * @param {import('./transform-recommendations-request').TransformedRecommendationsRequest} transformedRequest
 * @returns {TransformedRecommendationsResponse}
 */
export const transformRecommendationsResponse = (response, transformedRequest) => {
	const podResponse = response?.response || {};
	const results = podResponse.results || [];

	const seenIds = new Set();

	const items = results.map((result, index) => {
		const data = result.data || {};

		return {
			id: String(data.id ?? ''),
			name: result.value || data.name || '',
			position: index + 1,
			price: data.price,
			strategyId: result.strategy?.id || ''
		};
	}).filter(item => {
		if (!item.id || seenIds.has(item.id)) {
			return false;
		}

		seenIds.add(item.id);

		return true;
	});

	return {
		items,
		meta: {
			numResults: items.length,
			podDisplayName: podResponse.pod?.display_name || '',
			podId: podResponse.pod?.id || transformedRequest?.podId || '',
			resultId: response?.result_id || '',
			seedItemIds: transformedRequest?.seedItemIds || [],
			strategyId: items[0]?.strategyId || '',
			totalNumResults: podResponse.total_num_results || items.length
		}
	};
};
